// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const ACCESO = {
  mensaje: '¿Cuál es el problema de acceso que tienes?',
  opciones: [
    {
      boton: 'No puedo iniciar sesión',
      respuesta: 'Verifica que tu usuario y contraseña sean correctos. Si olvidaste tu contraseña, usa la opción "¿Olvidaste tu contraseña?" en la pantalla de inicio de sesión.',
    },
    {
      boton: 'Mi contraseña expiró',
      respuesta: 'Cuando la contraseña expira, el sistema te redirige automáticamente a la pantalla de cambio de contraseña. Sigue las instrucciones para crear una nueva.',
    },
    {
      boton: 'No tengo acceso a un módulo',
      respuesta: 'El acceso a módulos lo gestiona el administrador del sistema. Contacta a tu administrador para solicitar los permisos necesarios.',
    },
    {
      boton: 'La sesión se cierra sola',
      respuesta: 'La sesión se cierra automáticamente por inactividad como medida de seguridad. Si el problema es frecuente o inmediato, contacta a soporte.',
    },
    {
      boton: 'Error al seleccionar sucursal',
      respuesta: 'Si no aparece ninguna sucursal disponible o aparece un error, verifica con el administrador que tu usuario tenga sucursales asignadas.',
    },
  ],
}
